module.exports = "./img/28dcdad21216abdb96466db36eab7e70.png";